import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { IsotoposType } from "../../app/types/genericTables.types";

type UseIsotoposInstalacionType = {
  isotoposList: IsotoposType[];
  get: (id: IsotoposType["id"]) => IsotoposType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useIsotopos = create<UseIsotoposInstalacionType>((set, get) => ({
  loading: false,
  isotoposList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().isotoposList.find(
      (isotoposInstalacion) => isotoposInstalacion.id === id
    ),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Isotopos";
      const { data: response } = await getData(endpoint);
      set(() => ({
        isotoposList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching isotoposList:", error);
      set({ loading: false });
    }
  },
}));
